
import {zip as observableZip,  Subscription, Observable } from 'rxjs';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoggedInUserService } from '../../auth/logged.in.user';
import { Configuration } from '../../configuration';
import { Helpers } from '../../helpers';
import { GetEventDto } from '../../models/training/training.models';
import { TrainingService } from '../../services/training.service';

@Component({
    selector: 'training/read',
    template: require('./training.details.component.html'),
    styles: [require('./training.shared.css'), require('./training.details.component.css')]
})
export class TrainingDetailsComponent {

    event: GetEventDto;
    trainingService: TrainingService;
    routeParamsSub: Subscription;
    subscribed: boolean;

    constructor(trainingService: TrainingService,
        configuration: Configuration,
        helpers: Helpers,
        private router: Router,
        private route: ActivatedRoute,
        loggedInUserService: LoggedInUserService) {

        this.trainingService = trainingService;
        this.event = new GetEventDto();
        var user = loggedInUserService.getCurrentUser();
        this.subscribed = !user.canAdHoc('notSubscribed');
    }

    ngOnInit(): void {

        if (this.routeParamsSub) this.routeParamsSub.unsubscribe();
        this.routeParamsSub = this.route.params.subscribe(params => {
            const id = +params['id'];

            var eventObservable = this.trainingService.getEvent(id);

            observableZip(
                eventObservable,
                (event: GetEventDto) => ({ event }))
                .subscribe(results => {
                    this.event = results.event;
                });
        });
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/training/training.details.component.ts